import * as XLSX from 'xlsx';

export const downloadCSV = (data, filename) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const capitalize = string => {
  return string && typeof string === 'string' ? string?.charAt(0)?.toUpperCase() + string?.slice(1) : '';
};

export const formatArrayToOptions = (array, label, value) => {
  return array?.map(x => {
    return { value: x[value], label: x[label] };
  });
};

export const formatArrayToFilterOptions = (array, label, value) => {
  return array?.map(x => {
    return { value: x[value], text: x[label] };
  });
};

export const mpsToKmph = mps => {
  return 3.6 * mps;
};

export function numberWithCommas(x) {
  if (!x) return 0;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getPrevNextIds(records, currentId) {
  const index = records.findIndex(record => record.id === currentId);

  if (index === -1) return { prev_id: null, next_id: null };

  const prev_id = index > 0 ? records[index - 1].id : null;
  const next_id = index < records.length - 1 ? records[index + 1].id : null;

  return { prev_id, next_id };
}

export function readFileAsCSV(file) {
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob)) {
      return reject(new TypeError('File must be a Blob or File'));
    }

    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = e => {
      try {
        const wb = XLSX.read(e.target.result, { type: rABS ? 'binary' : 'array' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_csv(ws, { strip: true });

        resolve(data);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = reject;

    rABS ? reader.readAsBinaryString(file) : reader.readAsArrayBuffer(file);
  });
}

export function setDeep(target, path, val) {
  const keys = path.split('.');
  let cur = target;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (i === keys.length - 1) {
      cur[key] = val;
    } else {
      cur[key] = cur[key] ?? {};
      cur = cur[key];
    }
  }
}

export function getBase64(file) {
  if (!file) return Promise.resolve(null);

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function hasAllKeys(obj, keys) {
  if (!obj || !Array.isArray(keys)) return false;

  return keys.every(key => obj.hasOwnProperty(key) && obj[key] != null);
}
